export const BudgetPage = {
    isBudgetPageLoading: false,
    budgetPage: null,
    budgetPages: []
}